export const validate = () => {
  var errors = {};

  return [!Object.getOwnPropertyNames(errors).length, errors];
};

export default validate;
